<script context='module'>
  import WebsitePicker from './WebsitePicker.svelte';
  import { External as Ex } from '../external';

  export function showWebsiteList(title, message, websites, onSelect) {
    Ex.Tools.showWindow({
      withDarkBackground: true,
      showCloseButton: true,
      noNav: true,
      noTitle: true,
      width: 600,
      action: {
        onShow: (popup, context) => {
          new WebsitePicker({
            target: popup.getContentArea(),
            props: {
              title: title,
              message: message,
              websites: websites,
              onSelect: (website) => {
                onSelect(website, {
                  close: () => {
                    popup.close();
                  }
                });
              }
            }
          });
        }
      }
    });
  }

</script>

<script>
  import { External } from '../external';

  export let title, message, websites, onSelect;
</script>

<div class='switch-popup-wrapper full-size flex flex-col cpanel-prompt-dialog' style='height: 70vh;'>
  <a class='close-btn close-popup'><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></a>
  <h2 class='col20 ta-center flex-none'>{title}</h2>
  {#if message}
    <span class='col20 ta-center flex-none mt-25'>{message}</span>
  {/if}
  <div class='col20 f-left flex-1 mt-15' style='box-sizing: border-box; padding: 10px 40px 0 40px; overflow-y: auto; overflow-x: hidden'>
    {#each websites as website}
      <div class='col20 f-left funnel-inner-wrapper website-view' on:click={()=> onSelect(website)}>
        <div class='col20 f-left funnels-wrapper vertical-flex'>
          <div class='funnel-inner-texts mt-0 col-20 f-left'>
            <h4 class='col20 f-left'>{website.name}</h4>
            <span class='col20 f-left mt-10'>
                  {website.subdomain}.{External.Website.rootDomain}
              {#if website.date}
                &nbsp;|&nbsp;{website.date}
              {/if}
            </span>
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>

